import { Box, Container, Paper, Typography } from '@mui/material'

import Logo from '@/components/base/logo'
import { useCommonTranslation } from '@/hooks'

const Maintenance = () => {
  const { t } = useCommonTranslation()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.grey[900]} 0%, ${theme.palette.common.black} 100%)`
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
            background: 'none'
          }}
        >
          <Logo
            sx={{
              width: '20rem',
              display: 'inline-flex',
              pb: 2,
              color: (theme: { palette: { common: { white: string } } }) =>
                theme.palette.common.white
            }}
          />
          <Typography variant="h6" color="common.white" sx={{ mb: 1 }}>
            {t('maintenance.title')}
          </Typography>
          <Typography variant="body2" color="grey.500">
            {t('maintenance.message')}
          </Typography>
        </Paper>
      </Container>
    </Box>
  )
}

export default Maintenance
